import { NextPage } from 'next';
import styled from '@emotion/styled';

// colors
import { primary } from '@styles/Colors';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import Typography from '@components/_atoms/Typography';
import Title from '@components/_atoms/Title';

// 다국어 지원
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// constants
import { TypoVariant } from '@constants/atoms';
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';

const MarketingWrapper = styled.div`
  width: 100%;
  max-width: 1160px;
  padding: 110px 40px;
  margin: 0 auto;

  display: grid;
  row-gap: 32px;

  @media ${TABLET_MODE} {
    max-width: 768px;
  }

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 104px 0;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 24px;
  text-align: center;
`;

const SectionWrapper = styled.div`
  display: grid;
  row-gap: 24px;
`;

const List = styled.ul`
  padding-left: 24px;

  display: grid;
  row-gap: 8px;
`;
const ListItem = styled.li``;

const Marketing: NextPage = () => {
  const { t } = useTranslation('document');

  return (
    <>
      <DefaultLayout>
        <MarketingWrapper>
          <TitleWrapper>
            <Title content={t('marketing.title')} />
          </TitleWrapper>
          <Typography variant={TypoVariant.B2} color={primary.gray}>
            {t('marketing.pc-guide')}
          </Typography>
          <SectionWrapper>
            <Typography variant={TypoVariant.B3} color={primary.gray}>
              {t('marketing.content')}
            </Typography>
            <List>
              <ListItem>
                <Typography variant={TypoVariant.SH3} color={primary.gray}>
                  {t('marketing.section1')}
                </Typography>
              </ListItem>
              <Typography variant={TypoVariant.B3} color={primary.gray}>
                {t('marketing.sectionContent1')}
              </Typography>
              <ListItem>
                <Typography variant={TypoVariant.SH3} color={primary.gray}>
                  {t('marketing.section2')}
                </Typography>
              </ListItem>
              <Typography variant={TypoVariant.B3} color={primary.gray}>
                {t('marketing.sectionContent2')}
              </Typography>
              <ListItem>
                <Typography variant={TypoVariant.SH3} color={primary.gray}>
                  {t('marketing.section3')}
                </Typography>
              </ListItem>
              <Typography variant={TypoVariant.B3} color={primary.gray}>
                {t('marketing.sectionContent3')}
              </Typography>
              <ListItem>
                <Typography variant={TypoVariant.SH3} color={primary.gray}>
                  {t('marketing.section4')}
                </Typography>
              </ListItem>
              <Typography variant={TypoVariant.B3} color={primary.gray}>
                {t('marketing.sectionContent4')}
              </Typography>
              <ListItem>
                <Typography variant={TypoVariant.SH3} color={primary.gray}>
                  {t('marketing.section5')}
                </Typography>
              </ListItem>
              <Typography variant={TypoVariant.B3} color={primary.gray}>
                {t('marketing.sectionContent5')}
              </Typography>
            </List>
          </SectionWrapper>
        </MarketingWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['document', 'common', 'component'])),
  },
});

export default Marketing;
